<template>
<div class="row" v-loading="loading" element-loading-text="Guardando datos...">
  <div class="col-md-12">
      <div class="row">
          <div class="col-md-12">
            <div class="card vx-card">
              <div class="card-header bg-white">
                <h4 class="card-title">Parámetros</h4>
              </div>

              <div class="card-body">
                <form @submit.prevent="updateParameter()">
                <el-tabs tab-position="left" v-model="tab" @tab-click="changeTab">
                  <el-tab-pane v-for="p in parameters" :key="p.id" :label="p.name">
                    <div class="form-group">
                      <label>
                        Cierre de Caja
                      </label>
                      <el-switch
                        class="ml-4"
                        v-model="parameter.value"
                        name="test"
                        active-text="SI"
                        inactive-text="NO"
                      >
                      </el-switch>
                    </div>
                  </el-tab-pane>
                </el-tabs>

                <div class="col-md-12 text-center">
                  <vs-button type="gradient" button="submit">
                    <i class="fa fa-save"></i>
                    Guardar
                  </vs-button>
                </div>
              </form>
              </div>
            </div>
          </div>
        </div>
  </div>
</div>
</template>

<script>
import configurationService from '@/services/configurations.service';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'parameters',
  data() {
    return {
      parameters: [],
      parameter: {
        value: ""
      },
      tab: "",
      loading: true
    }
  },
  computed: {
  },
  methods: {
    updateParameter() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.loading = true;
          this.parameter.company_id = this.$route.params.company_id;
          configurationService.updateParameter(this.parameter)
          .then(res => {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: 'success'
            });
            this.loading = false;
          })
          .catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error'
            });
            this.loading = false;
          })
        } else {
          this.$message({
            showClose: true,
            message: 'faltan datos',
            type: 'error'
          });
            this.loading = false;
        }
      });  
    },
    getParameters() {
      let company_id = this.$route.params.company_id;
      configurationService.getParameters(company_id)
      .then(res => {
        this.parameters = res.data;
        this.parameters.forEach(i => {
            i.value = i.value && i.value != 0 ? true : false;
          });
        this.parameter = this.parameters[0]
        this.loading = false
      })
      .catch(error => {
        /*this.$notify({
          title: error.message,
          type: 'error' 
        })*/
        //JRA Cambio de notificacion por mensaje
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error'
        });
        this.loading = false;
      });
    },
    changeTab(name) {
      this.parameter = this.parameters.find((element, index) => {
        return index === parseInt(this.tab)
      })
    }
  },
  created() {
    this.getParameters();
  }
}
</script>

<style scoped>
</style>
